import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, ShieldCheck, Zap, CreditCard, MapPin } from 'lucide-react';
export function ClosingSection() {
  return <section className="bg-[#0A0A0A] py-24 px-4 text-white" data-id="element-69">
      <div className="container mx-auto max-w-4xl" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-16" data-id="element-71">
          <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight" data-id="element-72">
            La decisión más fácil que vas a tomar hoy
          </h2>

          <div className="text-left max-w-2xl mx-auto space-y-4 mb-10 text-lg text-gray-300" data-id="element-73">
            <p className="flex items-start gap-3" data-id="element-74">
              <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-75" />
              <span data-id="element-76">
                Podés seguir calculando a ojo y cruzando los dedos para que el
                presupuesto cierre.
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-77">
              <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-78" />
              <span data-id="element-79">
                Podés seguir perdiendo clientes porque tardás 3 días en pasarles
                el precio.
              </span>
            </p>
            <p className="flex items-start gap-3" data-id="element-80">
              <X className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-81" />
              <span data-id="element-82">
                Podés seguir quemando perfiles por errores de descuento.
              </span>
            </p>
          </div>

          <p className="text-xl md:text-2xl font-bold text-[#D4A017] max-w-3xl mx-auto italic" data-id="element-83">
            "Un solo perfil de línea A30 quemado te cuesta más que todo este
            sistema. La matemática es simple."
          </p>
        </motion.div>

        {/* Comparison Table */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.2
      }} className="bg-[#111111] rounded-2xl overflow-hidden border border-gray-800 mb-16" data-id="element-84">
          <div className="grid grid-cols-2 bg-black/50 p-4 border-b border-gray-800" data-id="element-85">
            <div className="text-center font-bold text-gray-400" data-id="element-86">
              Sin sistema
            </div>
            <div className="text-center font-bold text-[#D4A017]" data-id="element-87">
              Con Super Combo
            </div>
          </div>

          {[{
          bad: 'Calculás a ojo',
          good: 'Tabla exacta'
        }, {
          bad: 'Perdés perfiles',
          good: 'Cero desperdicio'
        }, {
          bad: 'Cliente en visto',
          good: 'Scripts que cierran'
        }, {
          bad: 'Margen 10%',
          good: 'Margen 35-40%'
        }, {
          bad: 'Trabajás de noche',
          good: 'Sistema en 20 min'
        }].map((row, i) => <div key={i} className="grid grid-cols-2 p-4 border-b border-gray-800/50 last:border-0" data-id="element-88">
              <div className="flex items-center justify-center gap-2 text-gray-400" data-id="element-89">
                <X className="w-4 h-4 text-red-500" data-id="element-90" /> {row.bad}
              </div>
              <div className="flex items-center justify-center gap-2 text-white font-medium" data-id="element-91">
                <Check className="w-4 h-4 text-green-500" data-id="element-92" /> {row.good}
              </div>
            </div>)}
        </motion.div>

        {/* Final CTA Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.4
      }} className="bg-gradient-to-b from-[#111111] to-black border border-[#D4A017]/50 rounded-3xl p-8 md:p-12 text-center shadow-[0_0_50px_rgba(212,160,23,0.1)]" data-id="element-93">
          <div className="flex flex-col items-center justify-center gap-2 mb-8" data-id="element-94">
            <span className="text-gray-500 line-through text-xl" data-id="element-95">
              VALOR REAL $276.000
            </span>
            <div className="flex items-center gap-4" data-id="element-96">
              <span className="text-white font-medium text-xl" data-id="element-97">PRECIO HOY</span>
              <span className="text-6xl font-black text-[#D4A017]" data-id="element-98">
                $19.990
              </span>
            </div>
            <span className="bg-green-500/20 text-green-400 font-bold px-4 py-1 rounded-full text-sm mt-2" data-id="element-99">
              Ahorrás $256.010
            </span>
          </div>

          <a href="https://solucionstore.shop/cart/45494138568895:1" className="w-full max-w-xl mx-auto bg-[#D4A017] hover:bg-[#b58812] text-black font-black text-xl md:text-2xl py-6 px-8 rounded-2xl shadow-[0_0_30px_rgba(212,160,23,0.4)] transition-all transform hover:scale-105 flex items-center justify-center gap-3 mb-8 block" data-id="element-100">
            🔥 SÍ, QUIERO EL SUPER COMBO AHORA →
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-gray-400 text-sm font-medium mb-10" data-id="element-101">
            <div className="flex items-center gap-1" data-id="element-102">
              <ShieldCheck className="w-4 h-4" data-id="element-103" /> Garantía 7 días
            </div>
            <div className="flex items-center gap-1" data-id="element-104">
              <CreditCard className="w-4 h-4" data-id="element-105" /> 12 cuotas sin interés
            </div>
            <div className="flex items-center gap-1" data-id="element-106">
              <Zap className="w-4 h-4" data-id="element-107" /> Acceso inmediato
            </div>
            <div className="flex items-center gap-1" data-id="element-108">
              <MapPin className="w-4 h-4" data-id="element-109" /> Hecho para Argentina
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8" data-id="element-110">
            <p className="text-gray-500 text-sm mb-4" data-id="element-111">
              Pagos seguros procesados por:
            </p>
            <div className="flex justify-center items-center gap-4 text-gray-400 font-medium text-sm" data-id="element-112">
              <span data-id="element-113">Mercado Pago</span>
              <span data-id="element-114">•</span>
              <span data-id="element-115">Visa</span>
              <span data-id="element-116">•</span>
              <span data-id="element-117">Mastercard</span>
              <span data-id="element-118">•</span>
              <span data-id="element-119">American Express</span>
            </div>
          </div>
        </motion.div>
      </div>

      <footer className="text-center text-gray-600 text-sm mt-24 pb-8" data-id="element-120">
        <p data-id="element-121">
          © 2026 Super Combo Carpintería en Aluminio — Todos los derechos
          reservados
        </p>
      </footer>
    </section>;
}